import { resolveThemeBaseColor } from 'fitify-ui-onboarding/src/components/GenderFunnel/Layout.Utils'
import { useTheme } from 'styled-components'

import {
  StyledPageBackground,
  StyledPageCorner,
} from 'components/GenderFunnel/Layout/PageBackground/PageBackground.Styled'

type Props = {
  backgroundStyle?: string
}

export const PageBackground = ({ backgroundStyle }: Props) => {
  const theme = useTheme()
  if (backgroundStyle === 'theme_gradient') {
    const { base, secondary } = resolveThemeBaseColor({
      backgroundStyle,
      theme,
    })
    return (
      <>
        <StyledPageCorner $color={base} $position="top" />
        <StyledPageBackground
          aria-hidden
          $bottomColor={secondary}
          $topColor={base}
        />
        <StyledPageCorner $color={secondary} $position="bottom" />
      </>
    )
  }
  return null
}
